import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { theme } from '../theme';
import { API_BASE } from '../api/config';

const Login = ({ onLoginSuccess }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const params = new URLSearchParams();
            params.append('username', username);
            params.append('password', password);

            const response = await axios.request({
                method: 'post',
                url: `${API_BASE}/auth/login`,
                data: params.toString(),
                withCredentials: true,
                timeout: 10000,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            let userData = response.data || {};
            if (!userData.role) {
                const me = await axios.get(`${API_BASE}/auth/me`, {
                    withCredentials: true,
                    timeout: 5000
                });
                userData = { ...userData, ...me.data };
            }

            if (userData.csrf_token) {
                localStorage.setItem('csrf_token', userData.csrf_token);
            }

            if (userData.access_token) {
                localStorage.setItem('access_token', userData.access_token);
            }

            localStorage.setItem('user_role', userData.role || '');
            localStorage.setItem('linked_sales_person', userData.linked_sales_person || '');

            onLoginSuccess(userData);
        } catch (err) {
            const status = err.response?.status;
            const body = err.response?.data;
            console.error('Login API check:', { status, body, message: err.message });
            const errorMsg = err.response?.data?.detail || (typeof body === 'string' ? body : null) || 'Login failed. Please check your credentials.';
            setError(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%)',
            padding: '20px'
        }}>
            <div style={{
                background: 'linear-gradient(145deg, rgba(20, 26, 44, 1) 0%, rgba(15, 20, 35, 1) 100%)',
                padding: '48px',
                borderRadius: '24px',
                border: `2px solid ${theme.colors.primary}`,
                width: '100%',
                maxWidth: '450px',
                boxShadow: theme.shadows.xl
            }}>
                <div style={{
                    marginBottom: '32px',
                    textAlign: 'center'
                }}>
                    <h1 style={{
                        margin: '0 0 8px 0',
                        color: theme.colors.text.primary,
                        fontSize: '32px',
                        fontWeight: '700',
                        letterSpacing: '-0.5px'
                    }}>
                        <span style={{ color: theme.colors.primary }}>Retail Sales AI</span>{' '}
                        <span>Dashboard</span>
                    </h1>
                    <p style={{
                        margin: 0,
                        color: theme.colors.text.secondary,
                        fontSize: '15px'
                    }}>
                        Powered by Blue Rhine Industries Analytics
                    </p>
                </div>

                <form onSubmit={handleSubmit}>
                    {error && (
                        <div style={{
                            color: theme.colors.danger,
                            marginBottom: '24px',
                            padding: '14px 18px',
                            border: `2px solid ${theme.colors.danger}`,
                            borderRadius: '12px',
                            backgroundColor: 'rgba(239, 68, 68, 0.1)',
                            fontSize: '14px'
                        }}>
                            {error}
                        </div>
                    )}

                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            color: theme.colors.text.primary,
                            marginBottom: '8px',
                            fontSize: '14px',
                            fontWeight: '600'
                        }}>
                            Username
                        </label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            autoFocus
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                borderRadius: '10px',
                                border: `2px solid ${theme.colors.border.default}`,
                                background: theme.colors.background.dark,
                                color: theme.colors.text.primary,
                                fontSize: '15px',
                                outline: 'none',
                                transition: 'all 0.2s ease',
                                boxSizing: 'border-box'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = theme.colors.primary;
                                e.target.style.boxShadow = `0 0 0 3px ${theme.colors.primary}33`;
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = theme.colors.border.default;
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: '28px' }}>
                        <label style={{
                            display: 'block',
                            color: theme.colors.text.primary,
                            marginBottom: '8px',
                            fontSize: '14px',
                            fontWeight: '600'
                        }}>
                            Password
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                borderRadius: '10px',
                                border: `2px solid ${theme.colors.border.default}`,
                                background: theme.colors.background.dark,
                                color: theme.colors.text.primary,
                                fontSize: '15px',
                                outline: 'none',
                                transition: 'all 0.2s ease',
                                boxSizing: 'border-box'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = theme.colors.primary;
                                e.target.style.boxShadow = `0 0 0 3px ${theme.colors.primary}33`;
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = theme.colors.border.default;
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            width: '100%',
                            padding: '14px',
                            background: `linear-gradient(135deg, ${theme.colors.primary} 0%, #ea580c 100%)`,
                            color: 'white',
                            border: 'none',
                            borderRadius: '10px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            fontWeight: '600',
                            fontSize: '16px',
                            transition: 'all 0.2s ease',
                            boxShadow: loading ? 'none' : `0 4px 12px rgba(249, 115, 22, 0.3)`,
                            opacity: loading ? 0.7 : 1
                        }}
                        onMouseEnter={(e) => {
                            if (!loading) {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = `0 6px 16px rgba(249, 115, 22, 0.4)`;
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!loading) {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = `0 4px 12px rgba(249, 115, 22, 0.3)`;
                            }
                        }}
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
